import React from 'react'
import {Link} from 'gatsby'

import Button8 from '../button8'
import {combine} from '../../styles/classname-utils'
import styles from './embed.module.scss'
import aloeDesignChair from '../../../img/vids/aloe-design-chair.mp4'
import aloeDesignChairPoster from '../../../img/aloe-design-chair-poster.jpg'

const PricingAdsSection = () => (
  <section className={combine('justify-content-center', styles.embedSection)}>
    <div className={combine('row justify-content-center align-items-center', styles.embedSectionRow)}>
      <div className='col-10 col-lg-5 mb-3 mb-lg-0'>
        <h2 className='text-center text-lg-left'>8th Wall Ads</h2>
        <p className='noto-sans-jp text8-lg text-center text-lg-left font8-medium'>
          Purchasing a commercial license for an AR experience that you will distribute via ads?
          Talk to our sales team about a custom license based on ad spend instead of views.
        </p>
      </div>
      <div className='col-lg-5'>
        <video
          className={combine('img-fluid float-lg-right mx-auto d-block', styles.embedSectionVideo)}
          poster={aloeDesignChairPoster}
          preload='auto'
          loop
          autoPlay
          muted
          playsInline
        >
          <source src={aloeDesignChair} type='video/mp4' />
          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>
    <div className='row justify-content-center mt-lg-3 mt-4'>
      <Link
        to='/ads'
        a8='click;ar-ads;click-pricing-ads-cta'
      >
        <Button8>
          Learn More
        </Button8>
      </Link>
    </div>
  </section>
)

export default PricingAdsSection
